import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { MATERIAL_TYPE, STATUSARRAY } from "../../_contstants/common";
import {
  createItem,
  findAllActiveItem,
  getItemById,
  updateItem,
} from "./services/item.services";
import { clearItemDetail } from "./itemSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { useLocation, useNavigate } from "react-router-dom";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import { IItemCategory } from "../itemcategory/itemCategoryModel";
import { findAllActiveProductSubCategory } from "../productsubcategory/services/productsubcategory.services";
import ImageArray from "./ImageArray";
import { IProductsubCategory } from "../productsubcategory/productsubcategoryModel";
import FormTextArea from "../../components/formFields/FormTextArea";
import { findAllActivePurity } from "../purity/services/purity.services";
import { IPurity } from "../purity/purityModel";
import {
  closeItemCategoryDrawerOpen,
  openItemCategoryDrawerOpen,
} from "../itemcategory/itemcategorySlice";
import { CustomAppDrawer } from "../../components/muidrawer/Drawer";
import CreateItemCategory from "../itemcategory/CreateItemCategory";
import {
  closeItemSubCategoryDrawerOpen,
  openItemSubCategoryDrawerOpen,
} from "../productsubcategory/productsubcategorySlice";
import CreateProductSubCategory from "../productsubcategory/CreateProductSubCategory";
import {
  closePurityDrawerOpen,
  openPurityDrawerOpen,
} from "../purity/puritySlice";
import CreatePurity from "../purity/CreatePurity";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import IteamArray from "./IteamArray";
import { findAllActiveProcess } from "../process/services/process.services";

const CreateItem: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const ItemDetail = useAppSelector((state) => state.item.ItemDetail);
  const loading = useAppSelector((state) => state.item.loading);
  const formLoading = useAppSelector((state) => state.item.formLoading);
  const ItemCategoryList = useAppSelector(
    (state) => state.itemCategory.ItemCategoryList
  );
  const itemCategoryDrawerOpen = useAppSelector(
    (state) => state.itemCategory.itemCategoryDrawerOpen
  );
  const itemSubCategoryDrawerOpen = useAppSelector(
    (state) => state.productsubcategory.itemSubCategoryDrawerOpen
  );
  const purityDrawerOpen = useAppSelector(
    (state) => state.purity.purityDrawerOpen
  );
  const PurityList = useAppSelector((state) => state.purity.PurityList);
  const ProductSubCategoryList = useAppSelector(
    (state) => state.productsubcategory.ProductSubCategoryList
  );
  const item_guid = location.state?.item_guid;
  const gridRef = useRef<any>(null);
  const [formKey, setFormKey] = useState(1);
  useEffect(() => {
    if (item_guid) {
      dispatch(getItemById(item_guid));
    }
  }, [item_guid]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [ItemDetail]);

  useEffect(() => {
    dispatch(findAllActivePurity());
    dispatch(findAllActiveItemCategory());
    dispatch(findAllActiveProductSubCategory());
    dispatch(findAllActiveItem());
    dispatch(findAllActiveProcess());
    return () => {
      dispatch(clearItemDetail());
    };
  }, []);

  const filterItems = (ItemCategoryID: number) => {
    if (ItemCategoryID) {
      const result = ProductSubCategoryList.filter((item: any) => {
        return item.item_category_id === ItemCategoryID;
      });
      return result.map((item: IProductsubCategory) => {
        return {
          value: item?.id,
          label: item?.item_subcategory_name,
        };
      });
    }
  };

  const handleSubmit = async (values: any) => {
    const formData = {
      item_category_id: values.item_category_id
        ? +values.item_category_id
        : null,
      item_name: values.item_name,
      // item_nick_name: values.item_nick_name,
      isphine: values?.isphine ? true : false,
      total_weight: values?.total_weight ? values?.total_weight : 0,
      total_qty: values?.total_qty ? values?.total_qty : 0,
      item_sub_category_id: values.item_sub_category_id
        ? +values.item_sub_category_id
        : null,
      purity_id: values?.purity_id ? values?.purity_id : null,
      material_type: values?.material_type ? values?.material_type : "",
      remarks: values.remarks,
      item_details: values.item_details
        ? values.item_details
            ?.filter((item: any) => item.item_id && item.qty)
            ?.map((item: any) => ({
              item_id: item.item_id,
              qty: item.qty,
            }))
        : [],
      isactive: values.isactive === 1,
    };

    const handleResponse = (response: any, successCallback: () => void) => {
      if (response?.meta?.requestStatus === "fulfilled") {
        successCallback();
      } else {
        console.error("Error in handleSubmit:", response);
      }
    };

    try {
      if (item_guid) {
        const editPayload = { item_guid, ...formData };
        const response = await dispatch(updateItem(editPayload));
        handleResponse(response, () => {
          dispatch(getItemById(item_guid));
          navigate("/item");
        });
      } else {
        const response = await dispatch(createItem(formData));
        handleResponse(response, () => {
          navigate("/item/edit", {
            state: { item_guid: response?.payload?.item_guid },
          });
        });
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
    navigate("/item");
  };

  const handleBack = () => {
    dispatch(closed());
    navigate("/item");
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {itemCategoryDrawerOpen && (
        <CustomAppDrawer
          open={itemCategoryDrawerOpen}
          closeDrawerFunction={closeItemCategoryDrawerOpen}
        >
          <CreateItemCategory />
        </CustomAppDrawer>
      )}
      {itemSubCategoryDrawerOpen && (
        <CustomAppDrawer
          open={itemSubCategoryDrawerOpen}
          closeDrawerFunction={closeItemSubCategoryDrawerOpen}
        >
          <CreateProductSubCategory />
        </CustomAppDrawer>
      )}
      {purityDrawerOpen && (
        <CustomAppDrawer
          open={purityDrawerOpen}
          closeDrawerFunction={closePurityDrawerOpen}
        >
          <CreatePurity />
        </CustomAppDrawer>
      )}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={ItemDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {item_guid ? "Update Product" : "Create Product"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  {item_guid ? (
                    <Typography.h5>
                      Product Id :{" "}
                      <span style={{ color: "green" }}>
                        {ItemDetail.item_id}
                      </span>
                    </Typography.h5>
                  ) : (
                    ""
                  )}
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="item_name"
                    label="Product Name"
                    placeholder="i.e. Gold Ring"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    name="item_nick_name"
                    label="Product Nick Name"
                    placeholder="i.e G-RN"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem> */}

                <GridLayoutItem>
                  <Field
                    name="item_category_id"
                    label="Category"
                    isAddNew={true}
                    isIndirect={true}
                    isDrawerInDrawer={true}
                    drawerName="itemcategoryForm"
                    CustomDrawerOpenFunction={openItemCategoryDrawerOpen}
                    placeholder="Select Category"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={ItemCategoryList?.map(
                      (category: IItemCategory) => {
                        return {
                          value: category?.ID,
                          label: category?.category_name,
                        };
                      }
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="item_sub_category_id"
                    label="Sub Category"
                    placeholder="Select Sub Category"
                    component={FormSelectionField}
                    isAddNew={true}
                    isIndirect={true}
                    isDrawerInDrawer={true}
                    drawerName="productsubcategoryForm"
                    CustomDrawerOpenFunction={openItemSubCategoryDrawerOpen}
                    astrike={true}
                    validator={requiredValidator}
                    options={
                      ProductSubCategoryList &&
                      filterItems(
                        formRenderProps.valueGetter("item_category_id")
                      )
                    }
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="material_type"
                    label="Material Type"
                    placeholder="Select Material Type"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={MATERIAL_TYPE?.map((material: any) => {
                      return {
                        value: material?.value,
                        label: material?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="purity_id"
                    label="Purity"
                    placeholder="Select Purity"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    isAddNew={true}
                    isIndirect={true}
                    isDrawerInDrawer={true}
                    drawerName="purityForm"
                    CustomDrawerOpenFunction={openPurityDrawerOpen}
                    astrike={true}
                    options={PurityList?.map((category: IPurity) => {
                      return {
                        value: category?.ID,
                        label: `${category.Carat}-${category?.purity}`,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2} rowSpan={2}>
                  <Field
                    name="remarks"
                    label="Remarks"
                    placeholder="Write here..."
                    component={FormTextArea}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"isactive"}
                    name={"isactive"}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    label={"Status"}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status.value,
                        label: status.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="isphine"
                    label="Is  Phine (gm)"
                    component={FormCheckbox}
                    labelClassName="fw-bold h6"
                    size="large"
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    marginTop: 10,
                    backgroundColor: "#f0f1ff",
                    padding: "10px 20px",
                  }}
                >
                  <Typography.h5>Opening Stock</Typography.h5>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="total_weight"
                    label="Total Weight  (gm)"
                    placeholder="0.000"
                    type="number"
                    format="n3"
                    component={FormNumericTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="total_qty"
                    label="Total Quantity"
                    placeholder="0.00"
                    format="n2"
                    component={FormNumericTextField}
                    // validator={requiredValidator}
                    // astrike={true}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <Button
                    type="button"
                    themeColor={"primary"}
                    style={{ marginRight: 4 }}
                    onClick={handleBack}
                  >
                    Go to Product List
                  </Button>
                  <ButtonWithLoading
                    label={!item_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: 20 }}>
              <GridLayout>
                <GridLayoutItem>
                  <Typography.h4>Used Items Details</Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={IteamArray}
                    name="item_details"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "end",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <Button
                    type="button"
                    themeColor={"primary"}
                    style={{ marginRight: 4 }}
                    onClick={handleBack}
                  >
                    Go to Product List
                  </Button>
                  <ButtonWithLoading
                    label={!item_guid ? "Create" : "Update"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />
                  <Button
                    type="button"
                    fillMode={"outline"}
                    themeColor={"primary"}
                    style={{ marginLeft: 4 }}
                    onClick={handleFormClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            {formLoading ? (
              <LoadingPanel gridRef={gridRef} />
            ) : (
              item_guid && (
                <ShadowCard style={{ marginTop: 10 }}>
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4>Documents Upload</Typography.h4>
                  </GridLayoutItem>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={ImageArray}
                    name="Images"
                  />
                </ShadowCard>
              )
            )}
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateItem;
